import { ReactNode } from "react"
import HupersApp from "./components/HupersApp"
import ThienSangWedding from "./components/ThienSangWedding"
import TpnrpLuckyWheel from "./components/TpnrpLuckyWheel"
import TpnrpTeamDeathMatch from "./components/TpnrpTeamDeathMatch"
import WebisAlarm from "./components/WebisAlarm"
import ProhanFood from "./components/ProhanFood"
import VscodeVnwExtension from "./components/VscodeVnwExtension"
import SkingekiNoKyojin from "./components/ShingekiNoKyojin"
import SpecialForce2Clone from "./components/SpecialForce2Clone"
import VnwPageSpeedInsights from "./components/VnwPageSpeedInsights"
import QbTpnrpLuckyWheel from "./components/QbTpnrpLuckyWheel"
import XeTraSua from "./components/XeTraSua"

// TODO: contents holder
export type TContentPageItem = {
    slug: string
    techStack: string[]
    content: ReactNode
    createdDate: string
    title: string
    shortDescription: string
    thumbnail: any
}

export const contents: TContentPageItem[] = [
    {
        slug: "xe-tra-sua",
        techStack: ['ChatGPT Work', 'Game Studio', 'Imagegen', 'Google Flow', 'ElevenLabs', 'Game', 'Vibe coding'],
        content: <XeTraSua />,
        createdDate: "2026-10-13",
        title: "Xe Trà Sữa - A Milk Tea Shop Game",
        shortDescription: "A browser game in Vietnamese where you run a milk tea shop. Buy ingredients, make drinks, and serve customers. A vibe coding project built with ChatGPT Work and the Game Studio plugin, with AI-made art, music, and sound effects.",
        thumbnail: require('../assets/projects/xe-tra-sua/painted-tray-holder-counter.jpg')
    },
    {
        slug: "qb-tpnrp-lucky-wheel",
        techStack: ['Lua', 'FiveM', 'QBCore'],
        content: <QbTpnrpLuckyWheel />,
        createdDate: "2025-07-05",
        title: "TPNRP Lucky Wheel for QBCore",
        shortDescription: "A Lucky Wheel script for the Diamond Casino on QBCore servers. It uses the casino wheel from GTA 5 and supports Game Build 3407 (Agents of Sabotage).",
        thumbnail: require('../assets/projects/qb-tpnrp-lucky-wheel/thumbnail.png')
    },
    {
        slug: "vietnamworks-page-speed-insights",
        techStack: ['Typescript', 'NodeJS', 'Strapi', 'ReactJS', 'VSCode', 'Vite'],
        content: <VnwPageSpeedInsights />,
        createdDate: "2024-04-02",
        title: "VietnamWorks Page Speed Insights",
        shortDescription: "A tool that checks website speed and SEO every day, so the team can track changes over time.",
        thumbnail: require('../assets/projects/vnw-page-speed/thumbnail.png')
    },
    {
        slug: "vscode-vietnamworks-extension",
        techStack: ['Typescript', 'Javascript', 'ReactJS', 'VSCode'],
        content: <VscodeVnwExtension />,
        createdDate: "2024-03-23",
        title: "VietnamWorks Extension for VSCode",
        shortDescription: "A VSCode extension that helps the team create merge requests from 'develop' to 'release', or from the current branch to 'develop'.",
        thumbnail: require('../assets/projects/vscode-vietnamworks-extension/vscode-vnw-extension-thumbnail.png')
    },
    {
        slug: 'thien-sang-wedding',
        title: 'My Wedding Guest Website',
        shortDescription: 'A website where guests can say if they will attend my wedding and share their food choices and allergies. It helps me count the guests and plan the meal.',
        thumbnail: require('../assets/projects/wedding/supabase_database_thumbnail.png'),
        techStack: ['Supabase', 'Firebase Hosting', 'ReactJS', 'Javascript', 'Typescript', 'AMP-Story'],
        content: <ThienSangWedding />,
        createdDate: '2023-03-04'
    },
    {
        slug: 'hupers-app',
        title: 'Hupers App - A Live Chat App',
        shortDescription: 'A chat app with live messages, notifications, and video calls. It uses Socket.IO, Firebase Cloud Messaging, and WebRTC.',
        thumbnail: require('../assets/projects/hupers/hupers_app_thumbnail.png'),
        techStack: ['Flutter', 'Dart', 'NodeJS', 'Javascript', 'Socket.io', 'WebRTC', 'MySQL', 'Firebase Cloud Messaging'],
        content: <HupersApp />,
        createdDate: '2021-02-01'
    },
    {
        slug: 'esx-tpnrp-teamdeathmatch',
        title: 'TPNRP Team Death Match - A FiveM Game Mode',
        shortDescription: 'A team shooting mode for GTA roleplay servers on FiveM. The screen design is based on CS:GO.',
        thumbnail: require('../assets/projects/esx_tpnrp_teamdeathmatch/thumbnail.png'),
        techStack: ['HTML', 'CSS', 'Javascript', 'Lua', 'MySQL', 'FiveM'],
        content: <TpnrpTeamDeathMatch />,
        createdDate: '2020-09-06'
    },
    {
        slug: 'esx-tpnrp-luckywheel',
        title: 'TPNRP Lucky Wheel - A FiveM Script',
        shortDescription: 'A FiveM script that lets players spin the Lucky Wheel from GTA 5 on their server.',
        thumbnail: require('../assets/projects/esx_tpnrp_luckywheel/thumbnail.png'),
        techStack: ['HTML', 'CSS', 'Javascript', 'Lua', 'MySQL', 'FiveM'],
        content: <TpnrpLuckyWheel />,
        createdDate: '2019-08-27'
    },
    {
        slug: 'prohan-food-app',
        title: 'Prohan Food App - Order Food Online',
        shortDescription: 'A small test app that lets you order food in five taps. It uses CodeIgniter (PHP) for the backend and Firebase Cloud Messaging for notifications.',
        thumbnail: require('../assets/projects/prohan-food/thumbnail.png'),
        techStack: ['Flutter', 'Dart', 'PHP', 'Codeigniter', 'MySQL', 'Firebase Cloud Messaging'],
        content: <ProhanFood />,
        createdDate: '2021-02-01'
    },
    {
        slug: 'special-force-2-clone-game',
        title: 'Special Force 2 - Game Clone',
        shortDescription: 'A game clone based on Special Force 2. All game assets belong to Dragonfly GF Co., LTD.',
        thumbnail: require('../assets/projects/special-force-2-clone/thumbnail.png'),
        techStack: ['C#', 'Unity3D', 'Game'],
        content: <SpecialForce2Clone />,
        createdDate: '2018-12-23'
    },
    {
        slug: 'webis-alarm',
        title: 'Webis Alarm - Task Notifications',
        shortDescription: 'An app that shows task notifications from my former company.',
        thumbnail: require('../assets/projects/webis_alarm/thumbnail.png'),
        techStack: ['HTML', 'CSS', 'Javascript', 'C#', 'CefSharp', 'Semantic-UI'],
        content: <WebisAlarm />,
        createdDate: '2017-03-27'
    },
    {
        slug: 'shingeki-no-kyojin-fan-game',
        title: 'Shingeki No Kyojin Fan Game',
        shortDescription: 'A fan game based on the anime "Attack on Titan".',
        thumbnail: require('../assets/projects/shingeki-no-kyojin-fan-game/thumbnail.png'),
        techStack: ['C#', 'Unity3D', 'Proton', 'Game'],
        content: <SkingekiNoKyojin />,
        createdDate: '2015-10-11'
    },
]
